// extracted by mini-css-extract-plugin
module.exports = {"Card":"Card_Card__3YkGk","Icon":"Card_Icon__rOf5F","Content":"Card_Content__3nJsr","content":"Card_content__3E-Zh"};